import Swal from "sweetalert2";

class Modal
{
  baseModal = null;

  constructor()
  {
    this.baseModal = this.generateBaseModal();
  }

  generateBaseModal()
  {
    return Swal.mixin({
      customClass: {
        container: 'modal',
      },
      buttonsStyling: false,
    });
  }

  errorModal(text)
  {
    return this.baseModal.fire({
      // icon: 'error',
      title: 'Oops...',
      text: text || 'Something went wrong!',
      confirmButtonText: 'Ok',
    });
  }

  getBaseModal()
  {
    return this.baseModal;
  }
}

export default Modal;